import { Component,HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { DocumentAIService } from '../../services/documentAI.service';
import { BusinessCenterService } from 'src/app/businessCenter/services/business-center.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-shared-hitl-panel',
  templateUrl: './shared-hitl-panel.component.html',
  styleUrl: './shared-hitl-panel.component.scss'
})
export class SharedHITLPanelComponent implements OnInit {
  @Input() caseId: any;
  @Input() caseRecordTypeId: any;
  containerHeight: number
  workItemList: any = [];
  GetHumanInLoopList: any = [];
  constructor(
    public authService: AuthService, 
    private service: DocumentAIService,
    private businessCenterService: BusinessCenterService,
    private route: ActivatedRoute,
    private router: Router,
    public toaster: ToastrService,
  ) {

  }
  ngOnInit(): void {
    this.getDataAfterRunHITL();
    this.GetHumanInLoop();
    this.setContainerHeight()
  }
 

  getDataAfterRunHITL() {
    this.businessCenterService.getWorkItems({
      businessEntityIdentifierFilter: this.caseId,
      workItemTypeIdFilter: undefined
    }).subscribe((result: any) => {
      const items = result?.items || [];
      console.log('Work Items from API:', items); // Debug log
      this.workItemList = this.transformWorkItemType(items);
      console.log('Transformed Work Items:', this.workItemList); // Debug log
    });
  }
  GetHumanInLoop() {
    this.GetHumanInLoopList = [];
    let queryString = `?CaseRecordTypeIdFilter=${this.caseRecordTypeId}&Sorting=creationTime desc`
    this.service
      .getCaseTypeHITL(queryString)
      .subscribe(
        (data: any) => {
          for (const item of data.result.items) {
            this.GetHumanInLoopList.push(item.caseTypeHITL)
          }
        });
  }

  transformWorkItemType(items: any[]): any[] {
    return items.map(item => {
      // First check if workItemType is already present in the API response
      let workItemType = item.workItemType || item.workItemTypeName || '';
      
      // If not present, derive from key
      if (!workItemType) {
        const key = item.key || '';
        if (key.startsWith('TSK')) {
          workItemType = 'Task';
        } else if (key.startsWith('APR')) {
          workItemType = 'Approval';
        } else if (key.startsWith('QRY')) {
          workItemType = 'Query';
        }
      }

      return {
        ...item,
        workItemType
      };
    });
  }
  runNowHITL(data: any) {
    this.service
      .runNowHITL(data.id, this.caseId, null)
      .subscribe(
        (data: any) => {
          this.toaster.success("HITL Run successfully");
          // Wait 5 seconds before refreshing the work items list
          setTimeout(() => {
            this.getDataAfterRunHITL();
          }, 5000);
        });
  }

  navigateToWorkItem(item: any) {
    if (item.workItemType === 'Task') {
      this.router.navigate(['/documentAI/tasks/view', item.id]);
    } else if (item.workItemType === 'Approval') {
      this.router.navigate(['/documentAI/approvals/view', item.id]);
    }
  }

  getWorkItemIcon(item: any): string {
    if (item.workItemType === 'Task') {
      return '../../../../assets/icons/task_icon_case.svg';
    } else if (item.workItemType === 'Approval') {
      return '../../../../assets/icons/Task.svg';
    }
    return '../../../../assets/icons/Task.svg'; // Default icon
  }
  setContainerHeight() {
    this.containerHeight = window.innerHeight - 200
    const layoutWrapperElement = document.querySelector('.layout-wrapper')
    if (layoutWrapperElement) {
        // layoutWrapperElement.classList.add('layout-static-inactive');
    }
  }
  @HostListener('window:resize', ['$event'])
      onResize(event: Event) {
          this.setContainerHeight()
      }
}
